import Loading from "../../results/loading";
import Random from "../../results/random";
import React from "react";
import { byAPrefix, byCodes, getPostNum } from "../../../constant/General";
import ContentWrapper from "./ContentWrapper";


const RenderPosA = ({
    posts,
    left = "35px",
    mr = "19px",
    top = "95px",
    field = "twoD",
    width = "140px",
    fontSize = "90px",
    right,
    bottom
}) => {
    return <div style={{
        top: top,
        left: left,
        right: right,
        bottom: bottom,
        fontSize: fontSize
    }} className="position-absolute d-flex post-tc">
        {posts.map((post, i) => {
            return <div
                style={{
                    height: "95px", marginTop: "19px"
                }}
                className="d-flex" key={i}>
                <div className="fw-bold d-flex justify-content-center" style={{
                    marginRight: mr, width: width
                }}>{getPostNum(post[field])}</div>
            </div>
        })}
    </div>
}


const ResultTCNight = ({ result, config, image }) => {
    const { results, rightResults } = result;

    const post = {
        postBCD: byCodes(rightResults, ["B", "C", "D"]),
        postA3D: byAPrefix(rightResults, 3),
        postA2D: byAPrefix(rightResults, 4),
    };

    return <ContentWrapper image={image} type={config.type} shift="ng">
        <div className="mt-live-ng w-50 overflow-hidden d-flex justify-content-end">
            <table style={{
                width: "810px"
            }} className="">
                <tbody>
                    {results.map((res, j) => {
                        const hlBG = config.ng.hlIndex.includes(j);
                        const style = {
                            background: hlBG ? config.hlBG : config.background
                        }
                        return <tr style={style} className={`row-${j}`} key={j}>

                            <td className="">
                                <div className="d-flex justify-content-around">
                                    {res.items.map((list, i) => {
                                        const style = config.ng.row[`row_${j}`]
                                        return <div className="" align="middle" key={`${j}_${i}`}>
                                            {list.map((num, index) => {
                                                if (num.includes("*")) {
                                                    return <div className=""
                                                        key={index}>
                                                        <Loading style={style?.loading ?? config.loading}
                                                            className="loading-res"
                                                            sizeDigit={num.length} />
                                                    </div>
                                                }
                                                if (num.includes("?")) {
                                                    let randomSt = style?.random ? {
                                                        ...style.random,
                                                        background: config.random.background
                                                    } : config.random
                                                    return <div key={index}>
                                                        <Random className="random-res" style={randomSt}
                                                            sizeDigit={num.length} />
                                                    </div>
                                                }
                                                return <div className="" style={{ ...style?.normal }}
                                                    key={index}>{num}</div>
                                            })}
                                        </div>
                                    })}
                                </div>
                            </td>


                        </tr>
                    })}
                </tbody>
            </table>
        </div>
        <div className="w-50 d-flex overflow-hidden justify-content-center align-items-center position-relative">
            <div className="w-100 h-100 position-relative">

                <RenderPosA mr="14px"
                    fontSize="80px"
                    width="165px"
                    top="10px"
                    left="200px"
                    posts={post.postA3D}
                    field="threeD" />

                <RenderPosA
                    top="130px"
                    left="10px"
                    width="170px"
                    posts={post.postA2D} />

                <div style={{
                    bottom: "25px", left: "255px",
                    fontSize: "100px"
                }} className="post-tc position-absolute fw-bold">
                    {post.postBCD.map((post, i) => {
                        return <div
                            style={{
                                height: "100px", marginTop: "28px"
                            }}
                            className="d-flex" key={i}>
                            <div style={{
                                marginRight: "105px", width: "150px"
                            }}>{getPostNum(post.twoD)}</div>
                            <div>{getPostNum(post.threeD)}</div>
                        </div>
                    })}
                </div>
            </div>
        </div>
    </ContentWrapper>

}

export default ResultTCNight;